module.exports = __webpack_public_path__ + "static/media/upload.8604e4fa.svg";